import React from 'react';
import './Skills.css';
import AOS from "aos";
import "aos/dist/aos.css";
import { FaNode, FaBootstrap, FaCodepen, FaCss3Alt, FaDiscord, FaGithubSquare, FaHtml5, FaJsSquare, FaNpm, FaReact, FaCode, FaDatabase,  } from 'react-icons/fa';
import ParticlesBg from 'particles-bg';

AOS.init();


const Skills = () => {
    return (
        <>
        <div className="skillStyle">
            <div className="container">
                <div className="row">
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaHtml5 size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">HTML5</h3>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-right" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaCss3Alt size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">CSS3</h3>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaBootstrap size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">Bootstrap</h3>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-right" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaJsSquare size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">JavaScript</h3>
                        </div>
                    </div>

                    <br/>
                    
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-right" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaReact size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">React JS</h3>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaNode size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">Node JS</h3>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-right" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaCode size='4rem' color="white"/>
                            </div>
                            <h5 className="text-white">Material UI</h5>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-left" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaDatabase size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">MongoDB</h3>
                        </div>
                    </div>

                    <br/>

                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-up-left" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaCodepen size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">Codepen</h3>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-up-right" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaNpm size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">NPM</h3>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-up-left" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaGithubSquare size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">Github</h3>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-8">
                        <div data-aos="fade-up" data-aos-delay="20" data-aos-duration="1500" data-aos-easing="ease-in-sine" className="bg-dark rounded m-4 px-5 pt-2">
                            <div className="text-white borderStyle p-3 m-2">
                                <FaDiscord size='4rem' color="white"/>
                            </div>
                            <h3 className="text-white">Discord</h3>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
        <ParticlesBg num={20} type="cobweb" bg={true} />
        </>
    );
};

export default Skills;